module.exports = __webpack_public_path__ + "static/media/BG_40.328206e4.png";